<app-loader *ngIf="loader.showLoader"></app-loader>

<div [dir]="direction" class="app-shell">
  <router-outlet></router-outlet>
  <app-chat-bot-wrapper></app-chat-bot-wrapper>
  <app-visitor-chatbot-wrapper [unlimitedUsage]="isOnSupportPage"
    [showFloatingButton]="isOnSupportPage"></app-visitor-chatbot-wrapper>
</div>
<tour-step-template>
  <ng-template let-step="step">
    <mat-card [dir]="direction" class="guide-step-card" (click)="$event.stopPropagation()">
      <mat-card-header class="guide-step-card-header">
        <div class="guide-step-header">
          <h3 class="guide-step-title">
            {{"GUIDE.TITLE" | translate}}
          </h3>
          <div class="guide-step-actions">
            <button [matMenuTriggerFor]="guideLangMenu" mat-mini-fab
              matTooltip="{{'COMMON.SELECT_LANGUAGE' | translate}}" class="guide-action-button"
              aria-label="Change language" title="{{'COMMON.SELECT_LANGUAGE' | translate}}">
              <mat-icon>translate</mat-icon>
            </button>
            <button mat-mini-fab matTooltip="{{ 'GUIDE.END_TOUR' | translate }}" class="guide-action-button"
              aria-label="End tour" title="{{ 'GUIDE.END_TOUR' | translate }}" (click)="end()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-menu #guideLangMenu="matMenu">
              @if (_translate.currentLang !== 'ar') {
              <button mat-menu-item (click)="changeLanguage('ar')">
                <span>{{'GUIDE.ARABIC' | translate}}</span>
              </button>
              }
              @if (_translate.currentLang !== 'en') {
              <button mat-menu-item (click)="changeLanguage('en')">
                <span>{{'GUIDE.ENGLISH' | translate}}</span>
              </button>
              }
              @if (_translate.currentLang !== 'fr') {
              <button mat-menu-item (click)="changeLanguage('fr')">
                <span>{{'GUIDE.FRENCH' | translate}}</span>
              </button>
              }
              @if (_translate.currentLang !== 'es') {
              <button mat-menu-item (click)="changeLanguage('es')">
                <span>{{'GUIDE.SPANISH' | translate}}</span>
              </button>
              }
            </mat-menu>
          </div>
        </div>

        <h3>
          {{ step.title | translate}}
        </h3>

      </mat-card-header>

      <mat-card-content class="mat-body" [innerHTML]="step.content | translate"></mat-card-content>

      <mat-card-actions [class.no-progress]="!step.showProgress">
        <button mat-button class="prev" [disabled]="!tourService.hasPrev(step)" (click)="tourService.prev()">
          {{ step.prevBtnTitle | translate }}
        </button>
        <ng-template [ngIf]="step.showProgress">
          <div class="progress">
            {{ tourService.steps?.indexOf(step) + 1 }} /
            {{ tourService.steps?.length }}
          </div>
        </ng-template>

        <ng-template [ngIf]="tourService.hasNext(step) && !step.nextOnAnchorClick">
          <button class="next" (click)="tourService.next()" mat-button>
            {{ step.nextBtnTitle | translate }}
          </button>
        </ng-template>
        <ng-template [ngIf]="!tourService.hasNext(step)">
          <button mat-button (click)="end()">
            {{ step.endBtnTitle | translate }}
          </button>
        </ng-template>
      </mat-card-actions>
    </mat-card>
  </ng-template>
</tour-step-template>